import React from 'react';
import { formatNumber } from './../../utils/dyzio';

import ProfileSummary from './../profile-summary';
import SocialBar from './../../components/social-bar';


const Influencer = ({ details }) => (
  <div className="row" id="influencer">
    <div className="col-md-2 col-sm-12">
      <img src={details.thumbnail} alt={details.name} className="img-circle img-responsive profile-image" />
    </div>
    <ProfileSummary profile={details} />
    <div className="col-md-4">
      <div className="profile-impact">
        <h2>{ details.totalSocialReach ? formatNumber(details.totalSocialReach) : '-' }</h2>
        <h5>Total reach</h5>
        <SocialBar
          item={{
            influencer: 2,
            data: {
              youtube: (details.aggregateYoutubeChannelStatistics && details.aggregateYoutubeChannelStatistics.subscriberCount) || 0,
              facebook: (details.facebookStatistics && details.facebookStatistics.likes) || 0,
              instagram: (details.instagramStatistics && details.instagramStatistics.followersCount) || 0,
              twitter: (details.twitterStatistics && details.twitterStatistics.followersCount) || 0,
            },
          }}
        />
      </div>
    </div>
  </div>
);

Influencer.propTypes = {
  details: React.PropTypes.object.isRequired,
};

export default Influencer;



// WEBPACK FOOTER //
// ./src/components/influencer/index.js